export default {
	en: {
		messages: {
			required: (field) => `The ${field.toLowerCase()} field is required.`,
			email: (field) => `The field ${field.toLowerCase()} is not valid.`,
			authorize: (field) => `You must authorize the field ${field.toLowerCase()}.`
		}
	}
}


// WEBPACK FOOTER //
// ./src/i18n/vee-validate/vee-validate_en.js